export enum SupportedLanguages {
  EN = 'en',
  FR = 'fr',
  ZH = 'zh',
}

export const PRIMARY_LANGUAGE = SupportedLanguages.EN

export const supportedLanguages = [PRIMARY_LANGUAGE, SupportedLanguages.FR, SupportedLanguages.ZH]
